import Swal from "sweetalert2";

export default function DeleteUserButton({
  token,
  usermanId,
  username,
  onSuccess,
}) {
  const handleDelete = async () => {
    if (!usermanId || !username) {
      Swal.fire("Error", "Data user tidak valid", "error");
      return;
    }

    const confirm = await Swal.fire({
      title: "Hapus User?",
      text: `User "${username}" akan dihapus dari User Manager & database lokal`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await fetch(
        "https://api.wifikamu.my.id/userman-user-delete",
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({
            userman_id: usermanId,
            username,
          }),
        }
      );

      const json = await res.json();

      if (!res.ok || !json.success) {
        throw new Error(json.message || "Gagal menghapus user");
      }

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: json.message,
        timer: 1500,
        showConfirmButton: false,
      });

      onSuccess?.();
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    }
  };

  return (
    <button
      onClick={handleDelete}
      className="
        px-3 py-1 text-sm rounded
        bg-red-600 text-white
        hover:bg-red-700
        dark:bg-red-700 dark:hover:bg-red-800
      "
    >
      Delete
    </button>
  );
}
